// 校验当前值
export const useValidator = (state, callbacks = []) => {
    return (params) => {
      return new Promise((resolve, reject) => {
        const { value, conf } = state;
        const { required, defErrorMsg, label } = conf;
        // 默认校验规则
        if (required && (!value || value?.length === 0)) {
          state.conf.error = true;
          state.conf.errorMsg = defErrorMsg || `${label} is required`;
          return reject(state);
        } else {
          state.conf.error = false;
        }
        // 存在自定义校验
        for (let i = 0; i < callbacks.length; i++) { 
            const { error, errorMsg } = callbacks[i] && callbacks[i](state, params) || {};
            if (error) {
                state.conf.error = true;
                state.conf.errorMsg = errorMsg || defErrorMsg;
                return reject(state);
            }
        }
        state.conf.error = false;
        state.conf.errorMsg = defErrorMsg;
        return resolve(state);
      })
    }
}